<template>
  <main>
    <section class="w-full">
      <DataTable
        :value="topicsDenouncesList"
        showGridlines
        class="custom-datatableForum !shadow-md rounded-md mb-16"
        v-if="
          denounceType === $t('labels.generic', { pt: 'Tópicos', en: 'Topics' })
        "
      >
        <Column
          field="topic.title"
          :header="$t('forum.listDenounces.topics.table.columns.title')"
          class="w-[37vw] max-w-[37vw] md:w-[25vw] md:max-w-[25vw] truncate"
          headerClass="!bg-h-primary-500  "
        >
        </Column>
        <Column
          :header="
            $t('forum.listDenounces.topics.table.columns.author')
          "
          class="max-w-[292px] w-[15vw] truncate"
          field="topic.userAuthor.name"
          headerClass="!bg-h-primary-500"
        >
        </Column>
        <Column
          :header="
            $t('forum.listDenounces.topics.table.columns.denounces')
          "
          field="denounces"
          class="table-style !max-w-32 w-28"
          headerClass="!bg-h-primary-500"
        >
          <template #body="{ data }">
            {{ data.denounces?.length }}
          </template>
        </Column>
        <Column
          :header="
            $t('forum.listDenounces.topics.table.columns.status')
          "
          class="table-style w-[12vw]"
          headerClass="!bg-h-primary-500"
        >
          <template #body>
            <p
              :class="[labelDenouncesStyle[statusOfDenounce?.value]]"
              class="px-1 text-sm rounded-2xl"
            >
              {{ statusOfDenounce?.label }}
            </p>
          </template>
        </Column>
        <Column
          headerClass="!bg-h-primary-500 w-[8vw] max-w-[120px]"
          class="!p-0"
        >
          <template #body="{ data }">
            <span class="!m-0 flex justify-center gap-4">
              <button
                @click="showDenounces(data)"
                v-tooltip.top="
                  $t('labels.generic', {
                    pt: 'Ver denúncias',
                    en: 'See denounces',
                  })
                "
                class="p-[11px] my-4"
              >
                <v-icon name="md-listalt-round" width="18" height="18"></v-icon>
              </button>
              <button
                v-tooltip.top="
                  $t('labels.generic', { pt: 'Ver tópico', en: 'See topic' })
                "
                class="p-[11px] my-4" @click="sendDisplayedItem(data)"
              >
                <v-icon name="md-search-sharp" width="18" height="18"></v-icon>
              </button>
            </span>
          </template>
        </Column>

        <template v-if="total > size" #footer>
          <div class="flex items-center justify-end py-2">
            <Paginator
              :rows="size"
              :totalRecords="total"
              :first="getFirstItemIndexActualPage()"
              :value="topicsDenouncesList"
              @page="onPaginate"
              class="md:w-full w-fit md:flex md:right-0 md:justify-end"
              :pageLinkSize="3"
            >
              <template #start>
                <p class="text-xs">{{ formatePaginatorText() }}</p>
              </template>
            </Paginator>
          </div>
        </template>
      </DataTable>
      <DataTable
        :value="commentsDenouncesList"
        class="custom-datatableForum mb-16 !shadow-md rounded-md"
        showGridlines
        v-else
      >
        <Column
          :header="
            $t('forum.listDenounces.comments.table.columns.author')
          "
          field="comment.userAuthor.name"
          class="max-w-[930px] w-[70vw]"
          headerClass="!bg-h-primary-500"
        >
        </Column>
        <Column
          :header="
            $t('forum.listDenounces.comments.table.columns.denounces')
          "
          field="denounces"
          class="table-style w-[10vw] max-w-36"
          headerClass="!bg-h-primary-500"
        >
          <template #body="{ data }">
            {{ data.denounces.length }}
          </template>
        </Column>
        <Column
          :header="
            $t('forum.listDenounces.comments.table.columns.status')
          "
          class="table-style w-[12vw]"
          headerClass="!bg-h-primary-500 "
        >
          <template #body>
            <p
              :class="[labelDenouncesStyle[statusOfDenounce?.value]]"
              class="px-1 text-sm rounded-2xl"
            >
              {{ statusOfDenounce?.label }}
            </p>
          </template>
        </Column>
        <Column
          headerClass="!bg-h-primary-500 w-[8vw] max-w-[120px]"
          class="!p-0"
        >
          <template #body="{ data }">
            <span class="!m-0 flex gap-4 justify-center">
              <button
                v-tooltip.top="
                  $t('labels.generic', {
                    pt: 'Ver denúncias',
                    en: 'See denounces',
                  })
                "
                class="p-[11px] my-4"
                @click="showDenounces(data)"
              >
                <v-icon name="md-listalt-round" width="18" height="18"></v-icon>
              </button>
              <button
                v-tooltip.top="
                  $t('labels.generic', {
                    pt: 'Ver comentário',
                    en: 'See comment',
                  })
                "
                class="p-[11px] my-4" @click="sendDisplayedItem(data)"
              >
                <v-icon name="md-search-sharp" width="18" height="18"></v-icon>
              </button>
            </span>
          </template>
        </Column>
        <template v-if="total > size" #footer>
          <div class="flex items-center justify-end">
            <Paginator
              :rows="size"
              :totalRecords="total"
              :value="commentsDenouncesList"
              @page="onPaginate"
              :first="getFirstItemIndexActualPage()"
              :pageLinkSize="3"
              class="md:w-full w-fit md:flex md:right-0 md:justify-end"
            >
              <template #start>
                <p class="text-xs">{{ formatePaginatorText() }}</p>
              </template>
            </Paginator>
          </div>
        </template>
      </DataTable>
    </section>
  </main>
</template>
<script lang="ts">
import { PropType, defineComponent } from "vue";
import { DenounceTopic, DenouncedComment } from "@/models/denounce.model";
import { PageState } from "primevue/paginator";
import { QueryParams } from "@/models/query-params.model";
export default defineComponent({
  name: "denounced-group-list",
  data() {
    return {
      params: new QueryParams(),
      labelDenouncesStyle: {
        ACCEPTED: "bg-h-success-200 text-h-success-500",
        NOT_ACCEPTED: "bg-h-neutral-200 text-h-neutral-700",
        WAITING_REVIEW: "bg-h-warning-100 text-h-warning-700",
      },
    };
  },
  props: {
    statusOfDenounce: {
      type: Object,
    },
    denounceType: {
      type: String,
    },
    commentsDenouncesList: {
      type: Array as PropType<DenouncedComment[]>,
      required: false,
    },
    topicsDenouncesList: {
      type: Array as PropType<DenounceTopic[]>,
      required: false,
    },
    size: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    formatePaginatorText(): string {
      return  this.$t("forum.listDenounces.tableDenounces.paginatorText", {
        first:this.getFirstItemIndexActualPage() ,
        last: (this.getFirstItemIndexActualPage() as number) +
          this.numberDenouncesPerPage() -
          1,
        total: this.total
      });
    },
    onPaginate(event: PageState): void {
      this.params.page = event.page;

      this.$emit("paginate", this.params);
    },
    showDenounces(denounces: DenouncedComment | DenounceTopic): void {
      this.$emit("denounces", denounces);
    },
    getFirstItemIndexActualPage(): number | undefined {
      if (this.$route.query.page) {
        return Number(this.$route.query.page) * Number(this.size) + 1;
      }
    },
    isComment(): boolean {
      return (
        this.denounceType ===
        this.$t("labels.generic", {
          pt: "Comentários",
          en: "Comments",
        })
      );
    },
    numberDenouncesPerPage(): number {
      let totalDenouncesPerPage = 0;
      if (this.isComment()) {
        totalDenouncesPerPage = this.commentsDenouncesList?.length as number;
      } else {
        totalDenouncesPerPage = this.topicsDenouncesList?.length as number;
      }
      return totalDenouncesPerPage;
    },
    sendDisplayedItem(denounce: DenouncedComment | DenounceTopic): void {
      this.$emit("displayedItem", denounce);
    }
  },
});
</script>
